import { useSelector } from 'react-redux';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function DayIcon({ sectionTitle, classNames }) {
  const { theme } = useSelector((state) => state.ui);

  return (
    <div className={classNames}>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hidden xs:inline"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.secondaryColour || DEFAULT_PRIMARY_COLOUR}
        />
        <path
          d="M30 26H25V31H30V26ZM29 15V17H21V15H19V17H18C16.89 17 16.01 17.9 16.01 19L16 33C16 34.1 16.89 35 18 35H32C33.1 35 34 34.1 34 33V19C34 17.9 33.1 17 32 17H31V15H29ZM32 33H18V22H32V33Z"
          fill="white"
        />
      </svg>
      <svg
        width="38"
        height="38"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 z-10 inline xs:hidden"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.secondaryColour || DEFAULT_PRIMARY_COLOUR}
        />
        <path
          d="M30 26H25V31H30V26ZM29 15V17H21V15H19V17H18C16.89 17 16.01 17.9 16.01 19L16 33C16 34.1 16.89 35 18 35H32C33.1 35 34 34.1 34 33V19C34 17.9 33.1 17 32 17H31V15H29ZM32 33H18V22H32V33Z"
          fill="white"
        />
      </svg>
      <div className="text-[20px] xs:text-[24px] leading-[29.05px] font-medium ml-[16px]">
        {sectionTitle}
      </div>
    </div>
  );
}
